/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoProductLogs200ResponseAllOfData } from './GetCostcoProductLogs200ResponseAllOfData';
import {
    GetCostcoProductLogs200ResponseAllOfDataFromJSON,
    GetCostcoProductLogs200ResponseAllOfDataFromJSONTyped,
    GetCostcoProductLogs200ResponseAllOfDataToJSON,
} from './GetCostcoProductLogs200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCostcoProductLogs200Response
 */
export interface GetCostcoProductLogs200Response {
    /**
     * 
     * @type {GetCostcoProductLogs200ResponseAllOfData}
     * @memberof GetCostcoProductLogs200Response
     */
    data: GetCostcoProductLogs200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCostcoProductLogs200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCostcoProductLogs200Response interface.
 */
export function instanceOfGetCostcoProductLogs200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCostcoProductLogs200ResponseFromJSON(json: any): GetCostcoProductLogs200Response {
    return GetCostcoProductLogs200ResponseFromJSONTyped(json, false);
}

export function GetCostcoProductLogs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoProductLogs200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCostcoProductLogs200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCostcoProductLogs200ResponseToJSON(value?: GetCostcoProductLogs200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoProductLogs200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

